export const questions = {
    "quizTitle": "Navigație maritimă – CLASA A,B",
    "quizSynopsis": "Model Navigație maritimă · 30 min · minim 21/30 (barem 7)",
    "progressBarColor": "#9de1f6",
    "nrOfQuestions": "152",
    "examConfig": {
        "personnelCategory": "CLASA A,B",
        "timeMinutes": 30,
        "passPercent": 70,
        "minCorrect": 21,
        "barem": 7,
        "modelName": "Navigație maritimă",
        "sections": [
            {
                "id": "Navigatie maritima",
                "label": "Navigație maritimă",
                "count": 30,
                "difficulty": 1
            }
        ],
        "totalQuestions": 30
    },
    "appLocale": {
        "landingHeaderText": "<questionLength> Intrebari",
        "question": "Intrebare",
        "startQuizBtn": "Incepe",
        "resultFilterAll": "Toate",
        "resultFilterCorrect": "Correct",
        "resultFilterIncorrect": "Incorect",
        "prevQuestionBtn": "Inapoi",
        "nextQuestionBtn": "Inainte",
        "multipleSelectionTagText": "Selectie multipla",
        "resultPageHeaderText": "Ai terminat. Ai <correctIndexLength> raspunsuri corecte din <questionLength> total.",
        "pickNumberOfSelection": "Alege <numberOfSelection>",
        "marksOfQuestion": "(<marks> puncte)"
    },
    "questions": [
        {
            "question": "1. Scara numerică a unei hărţi este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Raportul dintre lungimea şi lăţimea hărţii",
                "b) Un număr de catalog",
                "c) Raportul dintre lungimea unitară de pe Pământ şi corespondentul pe hartă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "2. În emisfera vestică, daca nava se deplasează spre vest",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decât latitudinea punctului de sosire",
                "b) longitudinea punctului de plecare este mai mică decât longitudinea punctului de sosire",
                "c) longitudinea punctului de plecare este mai mare decât longitudinea punctului de sosire"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "3. Temperatura apei de mare se exprimă în",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Milibari",
                "b) grade Celsius",
                "c) milimetri coloana de mercur"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "4. Corespunzător sensului convenţional de balizaj de la larg la uscat, in regiunea B, marcajele laterale au următoarele lumini",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribord-verde, babord- rosu",
                "b) tribord-alba fixa, babord- alba cu sclipiri",
                "c) tribord-rosu, babord-verde"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "5. Drumul giro al navei este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcţia de vizare la un reper",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcţia nord compas până la axul prova al navei",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcţia nord giro până la axul prova al navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "6. Relevmentul prova la un reper costier este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcţia de vizare la reperul",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcţia nord adevărat până la linia de vizare la reperul costier",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcţia nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "7. Latitudinea geografică este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arcul de ecuator măsurat de la meridianul Greenwich până la",
                "b) Arcul de paralel măsurat de la meridianul Greenwich până la meridianul locului",
                "c) Arcul de meridian măsurat de la ecuatorul terestru până la paralelul locului"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "8. In emisfera estică, daca nava se deplasează spre vest",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decât latitudinea punctului de sosire",
                "b) longitudinea punctului de sosire este mai mică decât longitudinea punctului de plecare",
                "c) longitudinea punctului de sosire este mai mare decât longitudinea punctului de plecare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "9. Daca vântul bate dinaintea traversului acesta produce",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) creşterea vitezei si derivă de vânt",
                "b) numai creşterea vitezei",
                "c) micşorarea vitezei si derivă de vânt"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "10. Relevmentul compas la un reper costier este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcţia de vizare la reperul",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcţia nord compas până la linia de vizare la reperul costier",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcţia nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "11. Longitudinea geografică este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arcul de ecuator măsurat de la meridianul Greenwich până la",
                "b) Arcul de paralel măsurat de la meridianul Greenwich până la meridianul locului",
                "c) Arcul de meridian măsurat de la ecuatorul terestru până la paralelul locului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "12. Viteza unei ambarcaţiuni se măsoară cu",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sonda",
                "b) barometrul",
                "c) lochul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "13. În emisfera sudica, daca nava se deplasează spre Nord",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de plecare este mai mica decât latitudinea punctului de sosire",
                "b) latitudinea punctului de plecare este mai mare decât latitudinea punctului de sosire",
                "c) longitudinea punctului de plecare este mai mica decât longitudinea punctului de sosire"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "14. Acul magnetic al compasului magnetic de la bordul navei se orientează pe direcţia",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nord adevărat",
                "b) Nord giro",
                "c) Nord compas"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "15. Marcajele laterale din sistemul de balizaj semnalizează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Limitele laterale ale unui pericol de navigaţie",
                "b) Limitele laterale ale unei serii de pericole de navigaţie",
                "c) Limitele laterale ale şenalului navigabil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "16. Drumul magnetic al navei este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcţia de vizare la un reper",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcţia nord compas până la axul prova al navei",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcţia nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "17. Relevmentul magnetic la un reper costier este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) unghiul din planul orizontului adevarat masurat de la axul prova al ambarcatiunii pana la directia de vizare la un reper costier;",
                "b) unghiul din planul orizontului adevarat masurat de la directia nord adevarat pana la linia de vizare la reperul costier;",
                "c) unghiul din planul orizontului adevarat masurat de la directia nord magnetic pana la axul prova al ambarcatiunii;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "18. Polii geografici sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cele două puncte în care axa de rotaţie intersectează suprafaţa Pământului",
                "b) Punctele în care linia ce trece prin centrul Pământului şi punctul navei intersectează suprafaţa Pământului",
                "c) Punctele în care linia ce trece prin centrul Pământului şi prin observatorul astronomic de la Greenwich intersectează suprafaţa Pământului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "19. Adâncimea apei se măsoară cu",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lochul",
                "b) sonda",
                "c) barometrul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "20. Reperele costiere utilizate pentru determinarea punctului navei pot fi",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) geamanduri, balize, scondri",
                "b) alte nave aflate la ancoră",
                "c) faruri"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "21. Drumul adevărat al navei este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcţia de vizare la un reper",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcţia nord adevărat până la axul prova al navei",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcţia nord compas până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "22. Daca vântul bate din travers acesta produce",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) creşterea vitezei si deriva de vânt",
                "b) doar creşterea vitezei",
                "c) derivă de vânt"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "23. Lumina alternativă a unui far are următoarea semnificaţie",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intensitatea luminii este variabila",
                "b) lumina fixa combinata cu intensificare de lumina",
                "c) culori diferite in sectoare strict delimitate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "24. Longitudinea geografică este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arcul de ecuator măsurat de la meridianul Greenwich până la",
                "b) Arcul de paralel măsurat de la meridianul Greenwich până la meridianul locului",
                "c) Arcul de meridian măsurat de la ecuatorul terestru până la paralelul locului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "25. Cartile pilot se corectează la zi utilizând",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) hartile rutiere",
                "b) avizele pentru navigatori",
                "c) hartile meteorologice in facsimil"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "26. Daca vântul bate din prova tribord acesta produce",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) micşorarea vitezei si deriva de vânt la tribord",
                "b) deriva de vânt la babord",
                "c) micşorarea vitezei si derivă de vânt la babord"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "27. Drumul compas al navei este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcţia",
                "b) unghiul din planul orizontului adevărat măsurat de la direcţia nord compas până la axul prova",
                "c) unghiul din planul orizontului adevărat măsurat de la direcţia nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "28. Harta marina este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reprezentarea la o anumita scara a unei zone oceanice;",
                "b) proiectia pe o suprafata sferica a Pamantului;",
                "c) proiectia Pamantului pe o suprafata oarecare."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "29. În emisfera nordică, daca nava se deplasează spre Nord",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de plecare este mai mica decât latitudinea punctului de sosire",
                "b) latitudinea punctului de plecare este mai mare decât latitudinea punctului de sosire",
                "c) longitudinea punctului de plecare este mai mica decât longitudinea punctului de sosire"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "30. Relevmentul adevărat la un reper costier este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Unghiul din planul orizontului adevărat măsurat de la axul prova al navei până la direcţia de vizare la reperul",
                "b) Unghiul din planul orizontului adevărat măsurat de la direcţia nord adevărat până la linia de vizare la reperul costier",
                "c) Unghiul din planul orizontului adevărat măsurat de la direcţia nord magnetic până la axul prova al navei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "31. Poziţia navei se poate determina, printre altele, prin măsurători de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatură",
                "b) relevmente",
                "c) salinitate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "32. Linia de credinţă a compasului magnetic de la bord materializează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Direcţia nord magnetic",
                "b) Axul longitudinal al navei",
                "c) Direcţia nord compas"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "33. Viteza ambarcatiunii se masoara cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sonda;",
                "b) barometrul;",
                "c) lochul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "34. Adâncimea apei se măsoară cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lochul;",
                "b) sonda;",
                "c) barometrul."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "35. Daca vantul bate dinaintea traversului acesta produce:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cresterea vitezei si deriva de vant;",
                "b) numai cresterea vitezei;",
                "c) micsorarea vitezei si deriva de vant."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "36. Daca vantul bate din travers acesta produce:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cresterea vitezei si deriva de vant;",
                "b) doar cresterea vitezei;",
                "c) deriva de vant."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "37. Daca vantul bate din prova tribord acesta produce:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) micsorarea vitezei si deriva de vant la tribord;",
                "b) deriva de vant la babord;",
                "c) micsorarea vitezei si deriva de vant la babord."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "38. Temperatura apei de mare se exprima in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) milibari;",
                "b) grade Celsius;",
                "c) milimetri coloana de mercur."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "39. Acul magnetic al compasului magnetic de la bordul ambarcatiunii se orienteaza pe directia:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nord adevarat;",
                "b) Nord giro;",
                "c) Nord compas."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "40. Cele mai sigure repere costiere utilizate pentru determinarea punctului ambarcatiunii sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) geamanduri, balize, scondri;",
                "b) orice constructie de la coasta;",
                "c) faruri de aterizare."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "41. Linia de credinta a compasului magnetic de la bord materializeaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) directia Nord magnetic;",
                "b) axul longitudinal al ambarcatiunii;",
                "c) directia Nord compas."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "42. Lumina unui far in izofaza are urmatoarea semnificatie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) durata de lumina este egala cu durata de",
                "b) intensitatea luminii este constanta;",
                "c) lumina fixa este combinata cu o intensificare de lumina."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "43. Corpul balizei marcajului cardinal de Vest este piturat in dungi orizontale dispuse de sus in jos astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) galben-negru-galben;",
                "b) negru-galben-negru;",
                "c) negru-galben."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "44. Corpul balizei marcajului cardinal de Nord este piturat in dungi orizontale dispuse de sus in jos astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) negru-galben-negru;",
                "b) galben-negru-galben;",
                "c) negru-galben."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "45. Corpul balizei marcajului cardinal de Est este piturat in dungi orizontale dispuse de sus in jos astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) negru-galben-negru;",
                "b) galben-negru-galben;",
                "c) negru-galben."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "46. Marcajul lateral de babord din regiunea A are ca semn de varf:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un con negru cu varful in sus;",
                "b) un cilindru verde:",
                "c) un cilindru rosu."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "47. Marcajul lateral de tribord din regiunea A are ca semn de varf:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Un con verde ( sau negru prin exceptie) cu varful in sus;",
                "b) un cilindru verde;",
                "c) un cilindru rosu."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "48. Marcajul de pericol izolat are ca semn de varf:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un con rosu cu varful in sus;",
                "b) o sfera de culoare rosie;",
                "c) o sfera de culoare neagra."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "49. Regula \"verde la tribord-rosu la babord\" valabila in regiunea A de balizaj se aplica marcajelor laterale astfel:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in sensul de la coasta catre larg;",
                "b) in sensul de larg catre coasta;",
                "c) este de competenta guvernelor statelor riverane."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "50. Conducatorul de ambarcatiune vede pe timp de noapte in prova tribord un marcaj care emite un grup de doua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de pericol izolat;",
                "c) un semn de vest."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "51. Conducatorul de ambarcatiune vede pe timp de noapte in prova babord un marcaj care emite un grup de doua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de pericol izolat;",
                "c) un semn de est."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "52. Conducatorul de ambarcatiune vede pe timp de noapte in prova un marcaj care emite un grup de noua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de pericol izolat;",
                "c) un semn de vest."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "53. Conducatorul de ambarcatiune vede pe timp de noapte in prova un marcaj care emite un grup de noua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn de ape sigure;",
                "b) un semn de sud;",
                "c) un semn de pericol izolat."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "54. Conducatorul de ambarcatiune vede pe timp de noapte in prova babord un marcaj care emite un grup de doua sclipiri albe care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn special;",
                "b) un semn de pericol izolat;",
                "c) un semn de vest."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "55. Cartul N este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) cardinal;",
                "c) inter-intercardinal;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "56. Cartul SW este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) cardinal;",
                "c) inter-intercardinal;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "57. Cartul SSE este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) cadinal;",
                "c) inter-intercardinal;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "58. Cartul E la N este un cart:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) intercardinal;",
                "b) inter- intercadinal;",
                "c) intermediar"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "59. Drumul adevarat al ambarcatiunii este egal cu 090 grade; rezulta ca ambarcatiunea se deplaseaza catre:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vest;",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "60. Drumul adevarat al ambarcatiunii este egal cu 000 grade; rezulta ca ambarcatiunea se deplaseaza catre:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nord",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "61. Drumul adevarat al ambarcatiunii este egal cu 180 grade; rezulta ca ambarcatiunea se deplaseaza catre:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vest;",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "62. Drumul adevarat al ambarcatiunii este egal cu 270 grade; rezulta ca ambarcatiunea se deplaseaza catre:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vest;",
                "b) Est;",
                "c) Sud;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "63. Drumul compas al ambarcatiunii se afla cuprins in cadranul NE de orizont. Care din urmatoarele valori de drum compas este corecta?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 212 grade;",
                "b) Dc = 034 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "64. Drumul compas al ambarcatiunii se afla cuprins in cadranul SE de orizont. Care din urmatoarele valori de drum compas este corecta?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 112 grade;",
                "b) Dc = 034 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "65. Drumul compas al ambarcatiunii se afla cuprins in cadranul SW de orizont. Care din urmatoarele valori de drum compas este corecta?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 102 grade;",
                "b) Dc = 234 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "66. Drumul compas al ambarcatiunii se afla cuprins in cadranul NW de orizont. Care din urmatoarele valori de drum compas este corecta?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = 102 grade;",
                "b) Dc = 234 grade;",
                "c) Dc = 328 grade."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "67. In navigatia maritima se utilizeaza harta in proiectie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stereografica;",
                "b) conica;",
                "c) Mercator."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "68. In emisfera nordica, daca ambarcatiunea se deplaseaza spre Nord:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) latitudinea punctului de sosire este mai mare decat latitudinea punctului de plecare;",
                "c) longitudinea punctului de plecare este mai mica decat longitudinea punctului de sosire;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "69. In emisfera nordica, daca ambarcatiunea se deplaseaza spre Sud:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de plecare este mai mica decat latitudinea punctului de sosire;",
                "b) latitudinea punctului de plecare este mai mare decat latitudinea punctului de sosire;",
                "c) longitudinea punctului de plecare este mai mica decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "70. In emisfera nordica, daca ambarcatiunea se deplaseaza spre Sud:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) latitudinea punctului de sosire este mai mare decat latitudinea punctului de plecare;",
                "c) longitudinea punctului de plecare este mai mica decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "71. In emisfera sudica, daca ambarcatiunea se deplaseaza spre Nord:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) latitudinea punctului de sosire este mai mare decat latitudinea punctului de plecare;",
                "c) longitudinea punctului de plecare este mai mare decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "72. In emisfera sudica, daca ambarcatiunea se deplaseaza spre Sud:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) latitudinea punctului de sosire este mai mare decat latitudinea punctului de plecare;",
                "c) longitudinea punctului de plecare este mai mare decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "73. In emisfera sudica, daca ambarcatiunea se deplaseaza spre Sud:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de plecare este mai mica decat latitudinea punctului de sosire;",
                "b) latitudinea punctului de plecare este mai mare decat latitudinea punctului de sosire;",
                "c) longitudinea punctului de plecare este mai mare decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "74. In emisfera estica, daca ambarcatiunea se deplaseaza spre Est:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) longitudinea punctului de plecare este mai mica decat longitudinea punctului de sosire;",
                "c) longitudinea punctului de plecare este mai mare decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "75. In emisfera estica, daca ambarcatiunea se deplaseaza spre Est:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) longitudinea punctului de sosire este mai mica decat longitudinea punctului de plecare;",
                "c) longitudinea punctului de sosire este mai mare decat longitudinea punctului de plecare."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "76. In emisfera estica, daca ambarcatiunea se deplaseaza spre Vest:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) longitudinea punctului de plecare este mai mica decat longitudinea punctului de sosire;",
                "c) longitudinea punctului de plecare este mai mare decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "77. In emisfera vestica, daca ambarcatiunea se deplaseaza spre Vest:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) longitudinea punctului de sosire este mai mica decat longitudinea punctului de plecare;",
                "c) longitudinea punctului de sosire este mai mare decat longitudinea punctului de plecare."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "78. In emisfera vestica, daca ambarcatiunea se deplaseaza spre Est:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) longitudinea punctului de sosire este mai mica decat longitudinea punctului de plecare;",
                "c) longitudinea punctului de sosire este mai mare decat longitudinea punctului de plecare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "79. In emisfera vestica, daca ambarcatiunea se deplaseaza spre Est:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) latitudinea punctului de sosire este mai mica decat latitudinea punctului de plecare;",
                "b) longitudinea punctului de plecare este mai mica decat longitudinea punctului de sosire;",
                "c) longitudinea punctului de plecare este mai mare decat longitudinea punctului de sosire."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "80. Marcajul cardinal de vest are ca semn de varf",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) doua conuri negre cu varful in sus;",
                "b) doua conuri negre unite la varf;",
                "c) doua conuri negre unite la baza;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "81. Deosebirea intre regiunea A si regiunea B de balizaj maritim se refera la:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) marcajul de pericol izolat;",
                "b) marcaje laterale;",
                "c) marcajul cardinal."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "82. Marcajul cardinal de Est are ca semn de varf:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) doua conuri negre cu varful in sus;",
                "b) doua conuri negre unite la varf;",
                "c) doua conuri negre unite la baza;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "83. In regiunea A, lumina marcajului lateral de tribord este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) verde;",
                "b) rosie;",
                "c) galbena."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "84. In regiunea A, lumina marcajului lateral de babord este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) verde;",
                "b) rosie;",
                "c) galbena."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "85. Lumina marcajului special este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) verde;",
                "b) rosie;",
                "c) galbena."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "86. Lumina marcajului de pericol izolat este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) alba;",
                "b) rosie;",
                "c) galbena."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "87. Lumina marcajului cardinal de nord este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) alba;",
                "b) rosie;",
                "c) galbena."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "88. Lumina marcajului cardinal de est este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rosie;",
                "b) alba;",
                "c) galbena."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "89. Lumina marcajului cardinal de sud este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rosie;",
                "b) galbena;",
                "c) alba."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "90. Lumina marcajului cardinal de vest este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rosie;",
                "b) galbena;",
                "c) alba."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "91. Lumina marcajului de ape sigure este de culoare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rosie;",
                "b) galbena;",
                "c) alba."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "92. Lumina marcajului cardinal de nord poate avea ritmul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sclipiri rapide ( 2+1);",
                "b) sclipiri rapide;",
                "c) 12 sclipiri rapide."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "93. Lumina marcajului cardinal de est poate avea ritmul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sclipiri rapide ( 2+1);",
                "b) 3 sclipiri rapide;",
                "c) 12 sclipiri rapide."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "94. Lumina marcajului cardinal de sud poate avea ritmul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sclipiri rapide ( 2+1);",
                "b) 6 sclipiri rapide;",
                "c) 6 sclipiri rapide plus o sclipire lunga."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "95. Lumina marcajului cardinal de vest poate avea ritmul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sclipiri rapide ( 2+1);",
                "b) 9 sclipiri rapide;",
                "c) 12 sclipiri rapide;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "96. Lumina marcajului de pericol izolat poate avea ritmul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) izofaza;",
                "b) 2 sclipiri rapide;",
                "c) 3 sclipiri rapide;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "97. Lumina marcajului de ape sigure poate avea ritmul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 2 sclipiri rapide;",
                "b) 3 sclipiri rapide;",
                "c) litera A in codul Morse."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "98. Precizia de masurare a drumului giro este de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1 grad;",
                "b) 0°.5;",
                "c) 0°.1."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "99. Precizia de masurare a drumului giro este de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1 grad;",
                "b) 0°.5;",
                "c) 0°.1."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "100. Conducatorul de ambarcatiune vede pe timp de noapte in prova un marcaj care emite sclipiri intermitente de culoare rosie. Acesta este: care se repeta regulat. Aceasta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn special;",
                "b) un semn de pericol izolat;",
                "c) un semn de babord."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "101. Conducatorul de ambarcatiune vede pe timp de noapte in prova un marcaj care emite sclipiri intermitente de culoare verde. Acesta este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un semn special;",
                "b) un semn de tribord;",
                "c) un semn de babord."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "102. Axa de rotatie a Pamantului este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) axa teoretica in jurul careia Pamantul executa miscarea sa naturala de rotatie in sens direct;",
                "b) axa teoretica ce trece prin centrul Pamantului si punctul ambarcatiunii;",
                "c) linia ce uneste centrul Pamantului si observatorul astronomic de la Greenwich."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "103. Axa de rotatie a Pamantului este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) axa teoretica ce uneste zenitul observatorului si centrul Pamantului;",
                "b) axa teoretica ce uneste cei doi poli geografici;",
                "c) linia ce uneste centrul Pamantului si observatorul astronomic de la Greenwich."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "104. Polii geografici sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cele doua puncte in care axa de rotatie intersecteaza suprafata Pamantului;",
                "b) doua puncte care depind de centrul Pmantului si punctul ambarcatiunii;",
                "c) doua puncte care depind de centrul Pamantului si observatorul Greenwich."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "105. Diferenta de latitudine geografica dintre punctul de plecare si cel de sosire este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) arcul de ecuator masurat de la meridianul punctului de plecare pana la meridianul punctului de sosire;",
                "b) arcul de meridian masurat de la paralelul punctului de plecare pana la paralelul punctului de sosire;",
                "c) arcul de meridian masurat de la ecuatorul terestru pana la paralelul punctului de sosire."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "106. Diferenta de longitudine geografica dintre punctul de plecare si cel de sosire este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) arcul de ecuator masurat de la meridianul punctului de plecare pana la meridianul punctului de sosire;",
                "b) arcul de meridian masurat de la paralelul punctului de plecare pana la paralelul punctului de sosire;",
                "c) arcul de meridian masurat de la ecuatorul terestru pana la paralelul punctului de sosire."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "107. Deplasarea est-vest este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Arcul de paralel masurat de la meridianul punctului de plecare pana la meridianul punctului de sosire;",
                "b) arcul de ecuator masurat de la meridianul punctului de plecare pana la meridianul punctului de sosire;",
                "c) arcul de meridian masurat de la ecuatorul terestru pana la paralelul punctului de sosire."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "108. Un cart are:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 12 grade;",
                "b) 32 grade;",
                "c) 11 grade, 25."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "109. Un reper costier se vede in relevment adevarat egal cu 090 grade; rezulta ca reperul se vede catre:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vest;",
                "b) Est;",
                "c) Sud."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "110. Lumina unui far apare la orizont intr-un relevment prova circular de 60 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) RpTd=060 grade;",
                "b) RpBd=060 grade;",
                "c) RpBd=060 grade;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "111. Lumina unui far apare la orizont intr-un relevment prova circular de 165 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) RpTd=165 grade;",
                "b) RpBd=165 grade;",
                "c) RpBd=025 grade;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "112. Lumina unui far apare la orizont intr-un relevment prova circular de 180 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova",
                "b) pupa;",
                "c) travers babord."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "113. Lumina unui far apare la orizont intr-un relevment prova circular de 90 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) travers tribord;",
                "b) travers babord;",
                "c) pupa."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "114. Lumina unui far apare la orizont intr-un relevment prova circular de 125 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribord, inapoia traversului;",
                "b) tribord, inaintea traversului;",
                "c) babord, inapoia traversului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "115. Lumina unui far apare la orizont intr-un relevment prova circular de 70 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribord, inapoia traversului;",
                "b) tribord, inaintea traversului;",
                "c) babord, inapoia traversului;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "116. Lumina unui far apare la orizont intr-un relevment prova circular de 230 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribord, inapoia traversului;",
                "b) tribord, inaintea traversului;",
                "c) babord, inapoia traversului;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "117. Lumina unui far apare la orizont intr-un relevment prova circular de 320 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribord, inapoia traversului;",
                "b) babord, inaintea traversului;",
                "c) babord, inapoia traversului;"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "118. Lumina unui far apare la orizont RpBd=130 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tribord, inaintea traversului;",
                "b) tribord, inapoia traversului;",
                "c) babord, inapoia traversului;"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "119. Lumina unui far apare la orizont RpBd=30 grade. Rezulta lumina farului se vede in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) babord, inaintea traversului;",
                "b) babord, inapoia traversului;",
                "c) tribord, inapoia traversului;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "120. Care dintre relatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc= Da+ d+ dc",
                "b) Dc= Da- d- dc",
                "c) Dc= Da+ d- dc"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "121. Care dintre relatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da= Dc+ d+ dc",
                "b) Da= Dc- d- dc",
                "c) Da= Dc+ d- dc"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "122. Care dintre relatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Rc= Ra+ d+ dc",
                "b) Rc= Ra- d- dc",
                "c) Rc= Ra+ d- dc"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "123. Care dintre relatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ra= Rc+ d+ dc",
                "b) Ra= Rc- d- dc",
                "c) Ra= Rc+ d- dc"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "124. Care dintre relatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Dc = Da - Δc;",
                "b) Dc = Da + Δc;",
                "c) Dc = Da - Δg."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "125. Care dintre relatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da= Dc - Δ c",
                "b) Da= Dc + Δ c",
                "c) Da= Dc - Δ g"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "126. Care dintre relatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Rc= Ra - Δ c",
                "b) Ra= Rc + Δ c",
                "c) Rc= Ra - Δ g"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "127. Drumul compas este Dc=202°.0 iar corectia totala compas este Δc = -2°.5. Care este valoarea drumului adevarat Da?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da= 204°.5",
                "b) Da= 200°.5",
                "c) Da= 199°.5"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "128. Drumul compas este Dc=078°.0 iar corectia totala compas este Δc = -1°.5. Care este valoarea drumului adevarat Da?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da= 077°.5",
                "b) Da= 078°.5",
                "c) Da= 079°.5"
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "129. Drumul giro este Dg= 147°.0 iar corectia totala giro este Δg = +3°.5. care este valoarea drumului adevarat Da?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da = 143 grade .5",
                "b) Da = 150 grade .5",
                "c) Da = 144 grade .5"
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "130. Ambarcatiunea in drum compas Dc = 100grade si masoara Rc=030 grade la un far. Farul se va vedea in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova tribord;",
                "b) prova babord;",
                "c) pupa babord."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "131. Ambarcatiunea in drum compas Dg = 330grade si masoara Rg=030 grade la un far. Farul se va vedea in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova tribord;",
                "b) prova babord;",
                "c) pupa babord."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "132. Ambarcatiunea in Da = 330 grade si masoara Rg = 030 grade. ambarcatiunea se va vedea in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova tribord;",
                "b) prova babord;",
                "c) pupa babord."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "133. O ambarcatiune se vede in prova. Relevmentul prova la acea ambarcatiunea este egal cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 090 grade;",
                "b) 000 grade;",
                "c) 180 grade."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "134. O ambarcatiune se vede in pupa. Relevmentul prova la acea ambarcatiunea este egal cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 090 grade;",
                "b) 000 grade;",
                "c) 180 grade."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "135. O ambarcatiune se vede in travers tribord. Relevmentul prova circular la acea ambarcatiunea este egal cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 090 grade;",
                "b) 000 grade;",
                "c) 180 grade."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "136. O ambarcatiune se vede in travers babord. Relevmentul prova circular la acea ambarcatiunea este egal cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 270 grade;",
                "b) 090 grade;",
                "c) 180 grade."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "137. Ambarcatiunea in Dg=080 grade si masoara Rg = 030 grade. ambarcatiunea se va vedea in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova tribord;",
                "b) prova babord;",
                "c) pupa babord."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "138. Ambarcatiunea in Dg=280 grade si masoara Rp Td = 030 grade. ambarcatiunea se va vedea in:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prova tribord;",
                "b) prova babord;",
                "c) pupa babord."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "139. Magnetii compensatori ai compasului magnetic au rolul;",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a indica directia nord compas;",
                "b) de a impiedica magnetizarea postamentului compasului magnetic;",
                "c) de a crea camp magnetic opus campului magnetic al ambarcatiunii."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "140. Magnetii compensatori de fier moale ai compasului magnetic sunt montati:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in cutia compasului;",
                "b) pe postament, langa cutia compasului;",
                "c) in interiorul postamentului."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "141. Magnetii permanenti transversali ai compasului magnetic sunt montati:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in cutia compasului;",
                "b) pe postament, langa cutia compasului;",
                "c) in interiorul postamentului."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "142. Magnetii permanenti longitudinali ai compasului magnetic sunt montati:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in interiorul postamentului;",
                "b) pe postament, langa cutia compasului;",
                "c) in cutia compasului."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "143. Magnetul permanent vertical (sau corectorul de banda) al compasului magnetic este montat:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe postament, langa cutia compasului;",
                "b) in interiorul postamentului;",
                "c) in cutia compasului."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "144. Sistemul de ace magnetice al compasului magnetic are urmatoarele caracteristici:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) acele magnetice sunt dispuse paralel, in numar par, in cutia compasului;",
                "b) acele magnetice sunt dispuse paralel, in numar impar, in cutia compasului;",
                "c) acele magnetice sunt dispuse perpendicular unele fata de altele, in numar par, in cutia compasului;"
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "145. Roza magnetica a compasului magnetic se sprijina pe;",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) peretele despartitor al cutiei compasului;",
                "b) pivot;",
                "c) acele magnetice."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "146. Cesculita are rolul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a micsora frecarea dintre pivot si roza;",
                "b) de a asigura plutirea rozei;",
                "c) de a mentine roza compasului intr-o pozitie rigida."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "147. Lichidul din cutia compasului magnetic are rol:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a impiedica miscarile dezordonate ale rozei;",
                "b) de a impiedica fenomenele corozive in interiorul cutiei compasului;",
                "c) de a asigura plutirea rozei cu o flotabilitate usor negativa."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "148. Compozitia lichidului din cutia compasului magnetic este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) alcool si apa;",
                "b) alcool, apa distilata si glicerina;",
                "c) apa distilata, ulei mineral si glicerina."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "149. Cand apar bule de aer in cutia compasului, Conducatorul de ambarcatiune are obligatia:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a completa cu apa distilata;",
                "b) de a completa cu glicerina;",
                "c) de a completa cu apa alcool."
            ],
            "correctAnswer": [
                1
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "150. Pe timpul cartului, Conducatorul de ambarcatiune are obligatia:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a compara permanent indicatiile compasului giro si ale repetitorului giro de pe radarul de navigatie ;",
                "b) de a compara permanent indicatiile compasului magnetic si ale compasului giro;",
                "c) de a compara permanent indicatiile compasului giro cu cele ale receptorului GPS."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "151. Sistemul cardanic al cutiei compasului are rolul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de a fixa rigid cutia compasului pe postament;",
                "b) de a preintampina rotirea postamentului;",
                "c) de a mentine in pozitie orizontala cutia compasului."
            ],
            "correctAnswer": [
                3
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        },
        {
            "question": "152. Pe timpul veghei la ancora, graparea ancorei se poate identifica:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) observand luminile arborate de navele din vecinatate;",
                "b) masurand periodic relevmente la doua repere fixe(costiere);",
                "c) ascultand cu atentie pentru a identifica zgomotele specifice."
            ],
            "correctAnswer": [
                2
            ],
            "section": "Navigatie maritima",
            "difficulty": 1
        }
    ]
};
